import { render, staticRenderFns } from "./Archival.view.vue?vue&type=template&id=b40402a2&scoped=true&"
import script from "./Archival.view.vue?vue&type=script&lang=js&"
export * from "./Archival.view.vue?vue&type=script&lang=js&"
import style0 from "./Archival.view.vue?vue&type=style&index=0&id=b40402a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40402a2",
  null
  
)

export default component.exports